import { Button, LinkButton, PublicButton } from '@yes.technology/react-toolkit'
import { getPublicButtonRest } from 'shared/utils'

import { CardButtonAttribution } from './CardCarousel.types'

export {
  getCardButtonAttribution,
  isLinkButtonPropsByObject,
  isModalButtonProps,
  isPublicButtonPropsByObject
} from './helpers/cardCarouselButton'

export type { CardButtonAttribution } from './CardCarousel.types'

export type CardCarouselButtonProps = {
  attribution: CardButtonAttribution
  onReadMore: () => void
}

function CardCarouselButton({
  attribution,
  onReadMore
}: CardCarouselButtonProps) {
  if (attribution?.type === null) {
    return null
  }

  if (attribution?.type === 'modal') {
    const props = attribution.props
    return (
      <Button onClick={onReadMore} style={props?.style}>
        {props?.label}
      </Button>
    )
  }

  if (attribution?.type === 'link') {
    const props = attribution.props
    const href = props?.link?.url
    if (href == null) return null
    return (
      <LinkButton
        href={href}
        target={props?.link?.target ?? '_self'}
        variant='primary'
        style={props?.style}
      >
        {props?.label}
      </LinkButton>
    )
  }

  if (attribution?.type === 'public') {
    const props = attribution.props
    const link = props?.link
    return (
      <PublicButton
        href={link?.url ?? props?.href}
        target={link?.target ?? props?.target}
        {...getPublicButtonRest(props ?? {})}
      >
        {props?.label ?? props?.children}
      </PublicButton>
    )
  }

  return null
}

export default CardCarouselButton
